/**
 * Sentry Connector for Browser based environments (non-Node)
 */
import * as Sentry from '@sentry/browser';

// emit events only if sentry is enabled for the current environment:
const beforeSend = (event: Sentry.Event): Sentry.Event | null => {
	// Catch ChunkLoadErrors so they will not be handled by Sentry
	if (
		event.exception &&
		event.exception.values &&
		event.exception.values.length > 0 &&
		event.exception.values[0].type === 'ChunkLoadError'
	) {
		return null;
	}

	return process.env.SENTRY_ENABLED ? event : null;
};

export function initSentry(release?: string): void {
	// 09.09.2026 15:12:45 - stefan.gallas
	// add ignore errors - mostly from external scripts, where we can not fix the bugs or problems
	Sentry.init({
		dsn: process.env.SENTRY_DSN,
		environment: (window as any).HARIBO.global.env.STAGE,
		release,
		beforeSend,
		ignoreErrors: [
			"Cannot read properties of undefined (reading 'length')",
			'Invalid call to runtime.sendMessage(). Tab not found.',
			"undefined is not an object (evaluating 'Object.getOwnPropertyDescriptor(_50,_177)[_178]')",
			"Can't find variable: _AutofillCallbackHandler",
			'NotAllowedError: The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.',
			"Expected an identifier but found 'jsc' instead",
			'ApiCommandError: Cannot fetch templates: request blocked by the browser',
			'null is not an object (evaluating \'buttonsWrapper.innerHTML=""\')'
		]
	});
}
export function captureAndLogError(error: Error): void {
	console.error(error);
	Sentry.captureException(error);
}

export default Sentry;
